// extracted by mini-css-extract-plugin
module.exports = {"container":"Setup__container___k194e","header":"Setup__header___zpzH0","main":"Setup__main___sqlsH","sidebar":"Setup__sidebar___KSYKW"};